import {
  Injector,
  Type,
  InjectionToken,
  InjectFlags,
  InjectOptions,
  ProviderToken,
} from '@angular/core';

export class ModalInjector implements Injector {
  constructor(
    private _parentInjector: Injector,
    private _additionalTokens: WeakMap<any, any>
  ) {}
  get<T>(
    token: ProviderToken<T>,
    notFoundValue: undefined,
    options: InjectOptions & { optional?: false | undefined }
  ): T;
  get<T>(
    token: ProviderToken<T>,
    notFoundValue: null | undefined,
    options: InjectOptions
  ): T | null;
  get<T>(
    token: ProviderToken<T>,
    notFoundValue?: T | undefined,
    options?: InjectOptions | InjectFlags | undefined
  ): T;
  get<T>(
    token: ProviderToken<T>,
    notFoundValue?: T | undefined,
    flags?: InjectFlags | undefined
  ): T;
  get(token: any, notFoundValue?: any): any;
  get(token: any, notFoundValue?: unknown, flags?: unknown): any {
    const value = this._additionalTokens.get(token);
    if (value) {
      return value;
    }
    return this._parentInjector.get<any>(token, notFoundValue);
  }

  // get<T>(
  //   token: Type<T> | InjectionToken<T>,
  //   notFoundValue?: T,
  //   flags?: InjectFlags
  // ): T;
  // get(token: any, notFoundValue?: any, flags?: any): Injector {
  //   const value = this._additionalTokens.get(token);
  //   if (value) {
  //     return value;
  //   }
  //   return this._parentInjector.get<any>(token, notFoundValue);
  // }
}
